import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const DatapointTypeAdmin_NewDatapointTypeView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    code: '',
    description: '',
    category: '',
    type: '',
    subsystemId: '',
    dataType: '',
    unit: '',
    formula: '',
    validRule: '{}'
  });


  const categoryList = [
    { key: "DATA",  value: "DATA" },
    { key: "ALARM", value: "ALARM" }
  ];

  const typeList = [
    { key: "DIRECT",  value: "DIRECT" },
    { key: "DERIVED", value: "DERIVED" }
  ];

  const [subsystemList,   setSubsystemList]   = useState([]);
  const [dataTypeOptions, setDataTypeOptions] = useState([]);
  const [unitOptions,     setUnitOptions]     = useState([]);


  // Initialize state
  useEffect(() => {

    fetchSubsystems();
    fetchDataTypes();
    fetchUnits();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSubsystems = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("subsystems");

        resolve(res.data);

        if (res.status === 200) {
          setSubsystemList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchDataTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-data-types");

        resolve(res.data);

        if (res.status === 200) {
          setDataTypeOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchUnits = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-units");

        resolve(res.data);

        if (res.status === 200) {
          setUnitOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  // UI Functions

  const [errMsg, setErrMsg] = useState('');


  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onCategorySelect = (key, event) => {
    setObjAttrs({ ...objAttrs, category: key })
  };

  const onTypeSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, type: key })
  };

  const onSubsystemClick = (key) => {
    setObjAttrs({ ...objAttrs, subsystemId: key })
  };

  const onDataTypeSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, dataType: key })
  };

  const onUnitClick = (key) => {
    setObjAttrs({ ...objAttrs, unit: key })
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_dp_type_code"));
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + "50");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-types?code=" + objAttrs.code);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Dup_code"));
        } else {
          validateOtherFields();
        }

        return;

      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if (objAttrs.description && (objAttrs.description.length > 200)) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");
    } else if (objAttrs.category === '') {
      setErrMsg(t("I18N_ERR_Need_dp_type_category"));
    } else if (objAttrs.type === '') {
      setErrMsg(t("I18N_ERR_Need_dp_type_type"));
    } else if (objAttrs.dataType === '') {
      setErrMsg(t("I18N_ERR_Need_dataType"));
    } else if (objAttrs.unit === '') {
      setErrMsg(t("I18N_ERR_Need_unit"));
    } else if (objAttrs.subsystemId === '') {
      setErrMsg(t("I18N_ERR_Need_subsys"));
    } else if (   (objAttrs.validRule)
               && (objAttrs.validRule !== '')
               && (!testJSON(objAttrs.validRule.trim()))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Valid_rule_need_valid_JSON"));
    } else {
      setErrMsg('');
      createNewDatapointType();
    }
  }

  const createNewDatapointType = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(objAttrs));

    if ((objAttrs.validRule == null) || (objAttrs.validRule === '')) {
      reqBody.validRule = null;
    } else {
      reqBody.validRule = JSON.parse(objAttrs.validRule.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("datapoint-types", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'600px', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_New_Datapoint_Type")}
          </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_DatapointType_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Row className={classes.admin_pages__field_label}>
            <Col>{t("I18N_Datapoint_type_code")}: *</Col>
            <Col>{t("I18N_Description")}:</Col>
            <Col>{t("I18N_Data_type")}: *</Col>
            <Col>{t("I18N_Unit")}: *</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col>
              <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code"
                     value={objAttrs.code}
                     onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col>
              <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                        value={objAttrs.description}
                        onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col>
              <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                title={!objAttrs.dataType ? t("common:I18N_DROPDOWN_PROMPT") :
                        t("I18N_" + (dataTypeOptions.find( ({ code }) => code === objAttrs.dataType )).code)}
                onSelect={onDataTypeSelect}>
                {dataTypeOptions.map((item, index) => {
                  return (
                    <Dropdown.Item key={index} eventKey={item.code} className={classes.dropdown_item_wrap}>
                      {t("I18N_" + item.code)}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </Col>
            <Col>
              <Dropdown>
                <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                  {!objAttrs.unit ? t("common:I18N_DROPDOWN_PROMPT") :
                   (unitOptions.find( ({ code }) => code === objAttrs.unit )).description +
                    ( (unitOptions.find( ({ code }) => code === objAttrs.unit )).symbol ?
                      ' (' + (unitOptions.find( ({ code }) => code === objAttrs.unit )).symbol + ')' : '')}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                  {unitOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} style={{maxHeight:'100px'}} eventKey={item.code} className={classes.dropdown_item_wrap} onClick={() => onUnitClick(item.code)}>
                        {item.description + (item.symbol ? ' (' + item.symbol + ')' : '')}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            <Col sm={3}>{t("I18N_Category")}: *</Col>
            <Col sm={3}>{t("I18N_Type")}: *</Col>
            <Col sm={3}>{t("I18N_Subsystem")}: *</Col>
            <Col sm={3}>{t("I18N_Formula")}:</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col sm={3}>
              <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                title={!objAttrs.category ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.category) }
                onSelect={onCategorySelect}>
                {categoryList.map((item, index) => {
                  return (
                    <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                      {t("I18N_" + item.value)}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </Col>
            <Col sm={3}>
              <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                title={!objAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.type) }
                onSelect={onTypeSelect}>
                {typeList.map((item, index) => {
                  return (
                    <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                      {t("I18N_" + item.value)}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </Col>
            <Col sm={3}>
              <Dropdown>
                <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                  {!objAttrs.subsystemId ? t("common:I18N_DROPDOWN_PROMPT") :
                     (subsystemList.find( ({ id }) => id === parseInt(objAttrs.subsystemId) )).code}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                  {subsystemList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onSubsystemClick(item.id)}>
                        {item.code}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col sm={3}>
              <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="formula"
                        value={objAttrs.formula}
                        onChange={(e) => onAttrsInputChange(e)} />
            </Col>
          </Row>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            <Col sm={6}>{t("I18N_Validation_rule")}:</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col sm={6}>
              <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="validRule"
                        value={objAttrs.validRule}
                        onChange={(e) => onAttrsInputChange(e)} />
            </Col>
          </Row>

          <hr className="solid" style={{ marginTop: '30px' }}></hr>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
            <span>{t("I18N_Req_fields")}</span>
          </Row>

          <Row>
            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleSubmit}>
                {t("I18N_Submit")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {errMsg}
              </span>
            </div>
          </Row>
        </Container>

      </Card>
    </>
  );
}

export default DatapointTypeAdmin_NewDatapointTypeView;
